import {defineStore} from 'pinia';
import {AxiosRequestConfig} from 'axios';
import {ref} from 'vue';

export interface AxiosRequestConfigLoader extends AxiosRequestConfig {
  showLoader?: boolean;
}

export const useLoaderStore = defineStore('LoaderStore', () => {
  const loading = ref(false);
  const requestsPending = ref(0);

  /** Increment the global request counter; first increment turns loading on. Pair with {@link endRequest}. */
  function beginRequest() {
    if (requestsPending.value === 0) {
      loading.value = true;
    }
    requestsPending.value += 1;
  }

  /** Decrement the counter after a request completes (success or error). Pair with {@link beginRequest}. */
  function endRequest() {
    if (requestsPending.value >= 1) {
      requestsPending.value -= 1;
    }
    if (requestsPending.value <= 0) {
      loading.value = false;
    }
  }

  function $reset() {
    loading.value = false;
    requestsPending.value = 0;
  }

  return {
    loading,
    requestsPending,
    beginRequest,
    endRequest,
    $reset,
  };
});
